import React from 'react';
import {withSnackbar} from "notistack";
import "./Modal.css"

import {
    Modal,
} from 'react-bootstrap';

import SupervisorApi from "../../services/ob-user/supervisor";
import {toast} from "react-toastify";

class ModalUnblockSupervisor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reason: '',
            showBlock: true,
            signupInfo: null
        };
    }

    // componentDidMount() {
    //     this.setState({oldpassword:'',newpassword:'',repassword:'',});
    // }
    //
    // componentWillReceiveProps(nextProps, nextContext) {
    //     if(nextProps.show){
    //         this.setState({oldpassword:'',newpassword:'',repassword:''});
    //     }
    // }

    // onSubmit =()=>{
    //     if(this.state.oldpassword.length <6 || this.state.newpassword.length <6 || this.state.repassword.length <6 ){
    //         this.props.enqueueSnackbar('Mật khẩu không được nhỏ hơn 6 kí tự !', {
    //             variant: 'error',
    //         });
    //     }else if(this.state.newpassword != this.state.repassword){
    //         this.props.enqueueSnackbar('Nhập lại mật khẩu chưa chính xác !', {
    //             variant: 'error',
    //         });
    //     }else if(this.state.oldpassword == this.state.newpassword){
    //         this.props.enqueueSnackbar('Mật khẩu mới không được giống mật khẩu cũ !', {
    //             variant: 'error',
    //         });
    //     }else {
    //         this.onBlock()
    //     }
    // }

    onUnblock = () => {
        let payload = {
            id: this.props.id
        }
        let userType = localStorage.getItem("ob_cl_userType")
        if (userType == "ADMIN") {
            SupervisorApi.adminOneBookUnblockSupervisor(payload, res => {
                if (res.success) {
                    toast.success(`Mở tài khoản Supervisor ${this.props.name} thành công!` )
                    this.props.onRefresh();
                } else {
                    toast.error("Thao tác thất bại. Vui lòng thử lại!")
                }
            })
        }else {
            SupervisorApi.unblockSupervisor(payload, res => {
                if (res.success) {
                    toast.success(`Mở tài khoản Supervisor ${this.props.name} thành công!` )
                    this.props.onHide();
                    this.props.onRefresh();
                } else {
                    toast.error("Thao tác thất bại. Vui lòng thử lại!")
                }
            })
        }
    }


    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>

                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>THÔNG BÁO</b></h1>
                        </div>

                        <div className='m-2'>
                            <label>Bạn có muốn mở khoá tài khoản Supervisor {this.props.name} không ?</label>
                        </div>

                        <div container item xs={12}>
                            <div item xs={12}>
                                <div className="align-right mt-3 mb-2">
                                    <button
                                        type="button"
                                        className="ml-4 col-3 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                        // disabled={this.state.oldpassword?.length == 0 || this.state.newpassword?.length == 0 || this.state.repassword?.length == 0 }
                                        onClick={() => this.onUnblock()}
                                    >
                                        <span className='d-flex justify-content-center'>
                                            Đồng ý
                                        </span>
                                    </button>
                                    <button
                                        type="button"
                                        className="ml-4 col-3 border-1-s w-50 type-button-fix btn btn-light"
                                        // disabled={this.state.oldpassword?.length == 0 || this.state.newpassword?.length == 0 || this.state.repassword?.length == 0 }
                                        onClick={this.props.onHide}
                                    >
                                        <span className='d-flex justify-content-center'>
                                            Hủy bỏ
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}


export default withSnackbar(ModalUnblockSupervisor);

